import React from 'react';
import MapsBase from './Maps';

const Maps = props => <MapsBase {...props} />;

export default Maps;
